"use strict";

var emitter = require('events').EventEmitter;
var inherits = require('inherits');
function Spinner(container) {
  this.maskContainer = document.createElement('div');
  this.maskContainer.style.display = 'none';
  this.maskContainer.className = 'spinner';
  this.maskContainer.innerHTML = '<div class="spinner-mask"></div><div class="spinner-logo"></div>';
  container.append(this.maskContainer);
}
inherits(Spinner, emitter);
Spinner.prototype.show = function show() {
  this.maskContainer.style.display = 'block';
  this.emit('show');
};
Spinner.prototype.hide = function hide() {
  this.maskContainer.style.display = 'none';
  this.emit('hide');
};
module.exports = Spinner;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/ui-spinner/dist/spinner.less');